<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/vehicle";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit Vehicles",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('vehicles.singular')) }},
    resourceRoute: {default: 'vehicles'},
    modelVariable: {default: 'vehicle'},
    form: {default() { return FormsModel; }},
    denyDelete: {type: Boolean, default: true}
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('vehicles.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t('vehicles.plural')),
          href: "/vehicles",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/vehicles/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/vehicles/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/vehicles/${this.$route.params.key}`).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      return this.$axios.put(`/vehicles/${this.$route.params.key}`, value)
    },
    delete() {
      return this.$axios.delete(`/vehicles/${this.$route.params.key}`)
    }
  }
}
</script>
